import { useEffect } from "react";
import "@/index.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { PlayerProvider } from "@/context/PlayerContext";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Music from "@/pages/Music";
import News from "@/pages/News";
import NewsDetail from "@/pages/NewsDetail";
import Bespoke from "@/pages/Bespoke";
import About from "@/pages/About";
import Press from "@/pages/Press";
import Discover from "@/pages/Discover";
import TrackPage from "@/pages/TrackPage";
import { RouteSeo } from "@/components/Seo";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/admin/Login";
import Admin from "@/pages/admin/Admin";

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <HelmetProvider>
      <PlayerProvider>
        <BrowserRouter>
          <ScrollTop />
          <Routes>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<Admin />} />
          <Route
            path="*"
            element={
              <Layout>
                <RouteSeo />
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/music" element={<Music />} />
                  <Route path="/music/:id" element={<TrackPage />} />
                  <Route path="/news" element={<News />} />
                  <Route path="/news/:id" element={<NewsDetail />} />
                  <Route path="/bespoke" element={<Bespoke />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/press" element={<Press />} />
                  <Route path="/discover" element={<Discover />} />
                  <Route path="/contact" element={<Contact />} />
                </Routes>
              </Layout>
            }
          />
        </Routes>
        <Toaster position="top-center" richColors />
        </BrowserRouter>
      </PlayerProvider>
    </HelmetProvider>
  );
}

export default App;
